<template>
    <div class="ur-text-field ur-input" :class="textfieldClass" :style="textfieldStyle">
        <input ref="input"
               :value="txtField"
               @input="txtField=$event.target.value"
               :type="inputType"
               :class="inputClass"
               :placeholder="placeholder"
               :disabled="disabled"
               :readonly="readonly"
               :onfocus="readonly&&'this.blur();'"
               :tabindex="tabindex"
               v-on="listenersWithoutInput"
               :autocomplete="autocomplete"
               @keyup.enter="enterHandler"
               @blur="validateOnEvent"/>
        <div class="ur-text-field__icon-wrap" v-show="withIcon">
            <ur-icon class="ur-text-field__icon-wrap__icon" @click="clickClear" v-if="clearable">close</ur-icon>
            <ur-icon class="ur-text-field__icon-wrap__icon" @click="toggleIcon" v-if="cPassword || cSearchable">{{icon}}</ur-icon>
        </div>
        <div v-if="messageShow || counter"
             class="ur-text-field__message ur-validator__message"
             :class="messageClass"
             :style="$_messageStyle()"><!--glue
        -->{{messageShow}}<!--glue
        --><div v-if="counter && counterShow === true" class="ur-text-field__counter"><!--glue
            -->{{typeof(txtField) === 'string'?getStringLength(txtField):0}}/{{counter}}<!--glue
        --></div><!--glue
    --></div>
    </div>
</template>

<script>
import urValidatorMixin from '@uidev/mixins/urValidator/urValidatorMixin.vue';
// ur-text-field 구성 요소는 사용자 제공 정보를 수집하는 데 사용됩니다.
// #ur-text-field components are used for collecting user provided information.
export default {
    name: 'aicc-text-field',
    mixins: [urValidatorMixin],
    inject: {
        urInput: {from:'urInput', default: () => undefined}
    },
    props:
    /* [FROM VALIDATOR] */
    // rules
    // disabled
    // lazy
    // noShake
    /********************/
    {
        // $ver: v0.1.0
        // $v-model
        // v-model로 바인딩되는 값으로, 텍스트필드의 값과 연계됩니다.
        // #The value bound to v-model, associated with the value of the textfield.
        // $tags IDE, value
        value: [String,Number],

        // $ver: v0.1.0
        // 텍스트 필드가 빈 값일 때 표시할 문자열 입니다.
        // #The string to display when the text field is empty.
        // $tags IDE, placeholder
        placeholder: {type: String},

        // $ver: v0.1.0
        // Guide 메시지로 표시할 문자열 입니다.
        // #The string to display as the guide message.
        guideMessage: {type: String, default: undefined},

        // $ver: v0.1.0
        // Success 메시지로 표시할 문자열 입니다.
        // #The string to display as a Success message.
        successMessage: {type: String, default: undefined},

        // $ver: v0.2.0
        // 모양입니다. 'border','underline','none' 중 하나를 입력해야 합니다.
        // #The shape. You must enter one of three types: border, underline, none
        // $default: border
        // $tags IDE, shape
        shape: {
            validator: function (value) {
                // The value must match one of these strings
                return ['border', 'underline','none'].indexOf(value) !== -1
            }
            // type: String,
            // default: 'border'
        },

        // $ver: v0.1.0
        // 컴포넌트를 Border 형태로 표현합니다.
        // #Represents a component in the form of a Border.
        // $default: false
        border: {type: Boolean, default: false},

        // $ver: v0.1.0
        // 컴포넌트를 Underline 형태로 표현합니다.
        // #Represents a component in underline form.
        // $default: false
        underline: {type: Boolean, default: false},

        // $ver: v0.1.0
        // 가이드, 성공, 안내메시지 표현 형태 속성입니다. 'heavy', 'light' 속성을 지정할 수 있습니다.
        // #Guide, Success, Announcement appearance attributes. You can specify the 'heavy' and 'light' attributes.
        messageStyle: {
            type: String,
            validator: function(value) {
                return ['heavy', 'light'].indexOf(value) !== -1;
            },
            default: 'heavy'
        },

        // $ver: v0.2.0
        // 종류입니다. 'none', 'password', 'searchable' 속성을 지정할 수 있습니다.
        // #The type. You must enter one of three types: none, password, searchable
        // $tags IDE, type
        type: {
            //type: String,
            validator: function(value) {
                return ['none','password', 'searchable'].indexOf(value) !== -1;
            },
            default: 'none'
        },

        // $ver: v0.1.0
        // 비밀번호 입력형태로 표현합니다. 숨김 값으로 입력되며, 우측 아이콘을 클릭하여 입력 값을 볼 수 있습니다.
        // #Expressed in password input form. It is entered as hidden value and you can see the input value by clicking the icon on the right.
        // $default: false
        password: {type: Boolean, default: false},

        // $ver: v0.1.0
        // 우측에 검색 아이콘을 표현합니다. 아이콘 클릭 시 'click-icon' 이벤트를 발생 시킵니다.
        // #The search icon is displayed on the right side. Raises 'click-icon' event when clicking icon.
        // $default: false
        searchable : {type: Boolean, default: false},


        // $ver: v0.1.0
        // 텍스트필드 초기화 기능 사용 여부입니다. 지정 시 초기화 아이콘이 나타나며, 클릭 시 현재 입력된 값을 초기화 할 수 있습니다.
        // #Whether to use the text field initialization function. Initialization icon appears when it is designated and can be initialized when clicked.
        // $default: false
        // $tags IDE, clearable
        clearable: {type: Boolean, default: false},

        // $ver: v0.1.0
        // 비활성화 상태로 전환합니다.
        // #Switch to inactive state.
        // $default: false
        // $tags IDE, disabled
        disabled: {type: Boolean, default: false},

        // $ver: v0.1.0
        // 읽기전용 상태로 전환합니다. 비활성화와는 다르게 커서를 위치시킬 수 있으며, 드래그로 문자열을 선택할 수 있습니다. disabled 속성이 활성화돼있을 경우 무시됩니다.
        // #Switch to read-only state. Unlike deactivation, you can position the cursor and drag to select a string. If the disabled attribute is active, it is ignored.
        // $default: false
        // $tags IDE, readonly
        readonly: {type: Boolean, default: false},

        // $ver: v0.1.0
        // Mask 표현식 입니다. #(숫자), A(대문자), a(소문자), N(숫자/대문자), n(숫자/소문자)와 특수기호의 조합으로 표현합니다.
        // #Mask expression. Expressed as a combination of # (number), A (uppercase), a (lowercase), N (number / uppercase), n (number / lowercase), and special symbols.
        // $default: null
        // $tags IDE, mask
        mask: {type: String, default: null},

        // $ver: v0.1.0
        // 입력될 문자열의 최대 길이 값을 지정합니다. urValidator 연계로 실제 값 유효성 검사를 수행해야 합니다. 이 속성이 입력되면 우측 하단에 입력된 문자열의 길이를 표시합니다.
        // #Specifies the maximum length value of the string to be entered. You must perform actual value validation with the urValidator linkage.
        // #When this property is entered, it displays the length of the entered text in the lower right corner.
        // $tags IDE, counter
        counter: {type: [String, Number], default: undefined},

        // 글자수 세는 단위
        // byte : 바이트 단위로 입력 글자수를 센다. 한글은 2, 영어 숫자는 1.
        // character : 영어든 한글이든 한자든 글자 하나는 1.
        counterUnit: {
            type: String,
            default: 'byte',
            validator: function (value) {
                return ['byte', 'character'].indexOf(value) !== -1
            }
        },
        
        // 글자수 숫자 보여주기 여부, 기본은 true
        counterShow: {
            type: Boolean,
            default: true,
        },

        // 실시간 Valid Check 여부, 기본은 true
        realTimeValidate :{
            type: Boolean,
            default: true,
        },

        // $ver: v0.2.0
        // 크기 입니다. 'large','medium','small' 두 가지 중 하나를 입력해야 합니다.
        // #The size You must enter one of three types: large, medium, small.
        // $default: medium
        // $tags IDE, size
        size: {
            validator: function (value) {
                // The value must match one of these strings
                return ['large','medium', 'small'].indexOf(value) !== -1
            },
            // type: String,
            //default: 'medium'
        },

        // $ver: v0.1.0
        // 컴포넌트를 Large 크기로 조정합니다.
        // #Resize the component to large size.
        // $default: false
        large: {type: Boolean, default: false},

        // $ver: v0.1.0
        // 컴포넌트를 Medium 크기로 조정합니다.
        // #Resize the component to medium size.
        // $default: false
        medium: {type: Boolean, default: false},

        // $ver: v0.1.0
        // 컴포넌트를 Small 크기로 조정합니다.
        // #Resize the component to Small.
        // $default: false
        small: {type: Boolean, default: false},

        // $ver: v0.1.2
        // tabindex를 설정합니다.
        // #Set tabindex.
        tabindex: {type:[Number,String]},

        // $ver: v0.1.0
        // large 속성의 약어입니다.
        // $abbr: large
        lg: {type: Boolean, default: false}, // large

        // $ver: v0.1.0
        // medium 속성의 약어입니다.
        // $abbr: medium
        md: {type: Boolean, default: false}, // medium

        // $ver: v0.1.0
        // small 속성의 약어입니다.
        // $abbr: small
        sm: {type: Boolean, default: false}, // small

        // $ver: v0.1.0
        // password 속성의 약어입니다.
        // $abbr: password
        pw: {type: Boolean, default: false}, // password

        // $ver: v0.1.0
        // readonly 속성의 약어입니다.
        // $abbr: readonly
        ro: {type: Boolean, default: false}, // readonly

        // $ver: v0.1.0
        // textarea 속성의 약어입니다.
        // $abbr: textarea
        ta: {type: Boolean, default: false}, // textarea

        // $ver: v0.1.0
        // border 속성의 약어입니다.
        // $abbr: border
        bor: {type: Boolean, default: false}, // border

        // $ver: v0.1.0
        // underline 속성의 약어입니다.
        // $abbr: underline
        ul: {type: Boolean, default: false}, // underline

        // $ver: v1.0.2
        // 너비를 지정합니다.
        // px 또는 % 형식으로 지정 가능합니다.
        // 단위를 생략한 경우 px로 간주합니다.
        // #Set width of text-field
        // #You can choose unit in PX and %
        // #If you skip the unit(just number) in value, we consider that unit is PX
        width : {type:[String, Number]},

        // $ver: v1.1.2
        // 자동완성을 허용할 양식 입력 필드를 지정할 수 있으며, 사용자 에이전트에게 어떤 정보에 대한 자동완성을 원하는지 안내할 수도 있습니다.
        // default: off
        autocomplete: {type: String, default: 'off'},
    },
    data: function () {
        return {
            /* [FROM VALIDATOR] */
            // hasError
            // errorMessage
            // showValid
            // shake
            /********************/
            default: {
                size: 'medium',
                style: 'border',
                type: 'none',
            },
            txtField: '', // shown in <input/> tag
            realText: '', // emitted data to parent component. if you use mask props, realText may differ from txt Field
            visible: false,
            predefinedMasks: {
                'phone': '### - ### - ####', /* phone : ### - ### - #### or #### - #### - #### */
                'credit-card': '#### - #### - #### - ####',
                'date': '##/##/####',
                'date-with-time': '##/##/#### ##:##',
                'social': '###-##-####',
                'time': '##:##',
                'time-with-seconds': '##:##:##',
                'number': '#,###,###,###,###,###,###,###,###,###,###,###,###,###',
            },
            allowedMasks: {
                '#': {
                    test: char => char.match(/[0-9]/),
                    convert: char => char
                },
                'A': {
                    test: char => char.match(/[A-Z]/i),
                    convert: char => char.toUpperCase()
                },
                'a': {
                    test: char => char.match(/[a-z]/i),
                    convert: char => char.toLowerCase()
                },
                'N': {
                    test: char => char.match(/[0-9A-Z]/i),
                    convert: char => char.toUpperCase()
                },
                'n': {
                    test: char => char.match(/[0-9a-z]/i),
                    convert: char => char.toLowerCase()
                }
            }
        };
    },
    computed: {
        /* [FROM VALIDATOR] */
        // isValidatable
        // el
        validateTarget() {return this.value;}, // validation setting
        /********************/

        $_size() {
            if((this.size && this.small) || (this.size && this.medium)|| (this.size && this.large)){
                console.warn("Props related size are duplicated.")
            }
            switch(this.size){
                case 'small':   return 'small';
                case 'medium' : return 'medium';
                case 'large' : return 'large';
            }

            if(this.large || this.lg) {return 'large'}
            if(this.medium || this.md) {return 'medium'}
            if(this.small || this.sm) {return 'small'}
            if(this.urInput) {return this.urInput.size}
            return this.default.size;
        },
        $_style() {
            if((this.shape && this.border) || (this.shape && this.underline)){
                console.warn("Props related shape are duplicated.")
            }
            switch(this.shape){
                case 'border':   return 'border';
                case 'underline' : return 'underline';
                case 'none' : return 'none';
            }

            if(this.border || this.bor) {return 'border'}
            if(this.underline || this.ul) {return 'underline'}
            return this.default.style;
        },
        inputType() {
            if ((this.password||this.pw||this.type === 'password') && !this.visible) {return 'password';}
            return 'text';
        },
        hasType() {
            // 2020-03-23 : skip default value of 'type' : none
            if( this.type !== 'none' && (this.password || this.searchable) ){
                console.warn("[UIDev] textField : Props related type are duplicated.")
            }
            /*/
            if((this.type && this.password) || (this.type && this.searchable)){
                console.warn("Props related type are duplicated.")
            }/**/
            switch(this.type){
                case 'password':  return true;
                case 'searchable' : return true;
                case 'none' : return false;
            }
            return false;
        },
        withIcon() {
            if (this.hasType) {return true;}
            if ((this.password || this.pw) || (this.clearable && this.txtField)) {return true;}
            if (this.searchable) {return true;}
            return false;
        },
        cSearchable(){
            return this.searchable || this.type === 'searchable';
        },
        cPassword(){
            return this.password || this.pw || this.type === 'password';
        },
        withTwoIcon() {
            return (this.cSearchable || this.cPassword) && this.clearable;
        },
        icon() {
            switch(this.type){
                case 'password':    return this.visible ? 'hide_password' : 'display_password';
                case 'searchable' : return 'search';
            }

            if (this.password||this.pw) {return this.visible ? 'hide_password' : 'display_password';}
            if (this.searchable) {return 'search';}
            return '';
        },
        textfieldClass() {
            let clazz = [];
            clazz.push('ur-text-field--'+this.$_size);
            clazz.push('ur-text-field--'+this.$_style);

            if(this.errorMessage) {clazz.push('ur-text-field--has-message')}
            if(this.hasError === true) {clazz.push('ur-validator--error')}
            if(this.showValid && this.hasError === false) {clazz.push('ur-validator--valid')}
            if(this.shake) {clazz.push('ur-validator--shake')}
            if(this.readonly || this.disabled) {clazz.push('ur-text-field--readonly')}
            return clazz;
        },
        textfieldStyle() {
            return {width:this.$_width}
        },
        $_width() {
            if(!this.width) return null;
            if(typeof this.width === 'number') return this.width + 'px';
            if(typeof this.width === 'string' && /^[0-9\.]*$/.test(this.width)) {
                return parseFloat(this.width)+'px';
            }
            return this.width;
        },
        withPwd(){
            if(this.password || this.pw) {return true;}
            return false;
        },
        inputClass() {
            return {
                'ur-text-field__input'             : true,
                'ur-text-field__input--with-icon'  : this.withIcon,
                'ur-text-field__input--with-two-icon': this.withTwoIcon,
                'ur-text-filed__input--only-eng'   : this.withPwd,
                'ur-text-filed__input--mask-number': (this.mask === 'number'),
                //'ur-validator--shake'              : this.shake,
            };
        },
        listenersWithoutInput() {
            //var vm = this;
            return Object.assign({}, this.$listeners, {
                input: function(event){ /*vm.$emit('input',event.target.value);*/}
            });
        },
        messageShow() {
            if(this.hasError === undefined) {
                return this.guideMessage;
            }
            if (this.hasError === true) {
                return this.errorMessage;
            }
            if (this.hasError === false) {
                return this.successMessage || this.guideMessage;
            }
            return undefined;
        },
        messageClass() {
            return ['ur-text-field__message--'+this.messageStyle];
        },

    },
    watch: {
        successMessage: {
            immediate: true,
            handler(val) {
                this.showValid = !!val;
            }
        },

        txtField(newText, oldText) {
            if (newText === oldText) {
                return;
            }
            if (this.mask == null) {
                this.realText = newText;
                // $ver: v0.1.0
                // $arg: updated value
                // 입력 값이 변경될 때, 변경된 값을 파라미터로 이벤트를 발생시킵니다.
                // #When the input value is changed, an event is triggered with the changed value as a parameter.
                this.$emit('input', newText);
                return;
            } else {
                if (this.mask === 'phone') {
                    newText = this.onlyNums(newText);
                    if (newText.length < 11) {
                        this.predefinedMasks['phone'] = '### - ### - ####';
                    } else {
                        this.predefinedMasks['phone'] = '### - #### - ####';
                    }
                } else if(this.mask === 'number'){
                    if (!newText) {
                        this.$emit('input', newText)
                    } else {
                        let newValue = String(newText)
                        let newNumbers = newValue.split('.')
                        let number = (1*this.onlyNums(newNumbers[0]))
                        let float = newNumbers.length > 1 ? this.onlyNums(newNumbers[1]) : ''

                        let text = number.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                        if (newNumbers.length > 1) text += '.' + float

                        let value = String(number)
                        if (newNumbers.length > 1) value += '.' + float

                        this.txtField = text
                        this.$emit('input', value)
                    }
                    return;
                }
                this.txtField = this.applyMask(newText, this.mask);
                this.$emit('input', String(this.realText));
                return;
            }
        },
        value: {
            immediate: true,
            handler(newVal, oldVal) {
                this.txtField = newVal;
                // 1. 실시간 Option이 활성화일 경우 Valid 검사
                // 2. 페이지 첫 진입시 빈 칸인 경우 Valid 검사 제외
                if(this.realTimeValidate && this.realTimeValidate === true) {
                    if((!newVal || newVal === null) && (!oldVal || oldVal === null)) {
                        return;
                    }
                    this.validateOnEvent();
                    if(this.isValid() === false) {
                        this.$emit('invalid');
                    }
                }
            }

            // counter를 초과하면 Max Length 이후를 자르는 경우
            /*
             handler(newVal, oldVal) {
                 if (this.counter && this.getStringLength(newVal) > this.counter) {
                     const cursorPosition = this.$refs['input'].selectionStart;
                    if (this.counterUnit === 'byte') {
                        newVal = aiccUtils.sliceStringByByte(newVal, this.counter);
                    } else if (this.counterUnit === 'character') {
                        newVal = newVal.substring(0, this.counter);
                    }
                    this.txtField = newVal;
                    this.$nextTick(() => {
                        this.$refs['input'].setSelectionRange(cursorPosition, cursorPosition);
                    });
                 } else {
                     this.txtField = newVal;
                 }
             }
             */
        },
    },
    methods: {
        /* [FROM VALIDATOR] */
        // validate()        --+
        // isValid()         --+-- exposed methods for manual validate control
        // clearValidation() --+
        // vavlidateOnEvent() -> should be set by each component which uses urValidatorMixin
        /********************/

        onlyNums(_text) {
            let ret = '';
            var text = ""+_text;
            for (var i = 0; i < text.length; i++) {
                if (this.allowedMasks['#'].test(text[i])) {
                    ret += text[i];
                }
            }
            return ret;
        },
        applyMask(text, mask) {
            const predefined = this.predefinedMasks[mask];
            const masks = predefined || mask;
            const masked = masks.split('');
            let textIdx = 0;
            let maskIdx = 0;
            let maskedText = '';
            this.realText = '';
            while (maskIdx < masked.length && textIdx < text.length) {
                let m = masked[maskIdx];
                let c = text[textIdx];
                if (this.isMask(m)) {
                    if (this.allowedMasks[m].test(c)) {
                        textIdx++;
                        maskIdx++;
                        this.realText += c;
                        maskedText += this.allowedMasks[m].convert(c);
                    } else {
                        return maskedText;
                    }
                } else {
                    if (m === '%') {
                        maskIdx++;
                        if(masked.length === maskIdx) {
                            console.warn('[UR-TEXT-FIELD] % is escape character in mask. If you want to show % character, use %% instead.');
                        } else {
                            m = masked[maskIdx];
                        }
                    }
                    if (c === m) {
                        textIdx++;
                    }
                    maskIdx++;
                    maskedText += m;
                }
            }
            return maskedText;
        },
        isMask: function (mask) {
            return this.allowedMasks.hasOwnProperty(mask);
        },
        toggleIcon: function () {
            if (this.password || this.type === 'password') {
                this.visible = !this.visible;
            }  else if (this.searchable || this.type === 'searchable'){
                // $ver: v0.1.0
                // $arg: value
                // searchable 속성으로 표시된 검색아이콘을 클릭할 때, 현재 값을 파라미터로 이벤트를 발생시킵니다.
                // #When clicking on the search icon marked with the searchable property, an event is triggered with the current value as a parameter.
                this.$emit('click-icon', this.txtField);
            }
        },
        clickClear() {
            this.txtField = '';
            this.$emit('input', '');
            this.$emit('click-icon-clear', '');
        },
        enterHandler: function () {
            // $ver: v0.1.0
            // $arg: value
            // 엔터 키 입력 시, 현재 값을 파라미터로 이벤트를 발생시킵니다.
            // #When enter key is pressed, an event is triggered with the current value as a parameter.
            this.$emit('enter', this.txtField);
        },
        focus() {this.$refs.input.focus();},
        blur() {this.$refs.input.blur();},
        getStringLength() {
            if (this.counterUnit === 'byte') {
                return aiccUtils.getStringByteSize(this.txtField);

            } else if (this.counterUnit === 'character') {
                return this.txtField.length;

            } else {
                return 0;
            }
        },
    },
};
</script>
